
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/area.png';
import example1 from './images/area-2.png';
import example2 from './images/area-3.png';
import { EchartsLineChartProps, EchartsLineFormData } from './types';
 
export default class EchartsLineChartPlugin extends ChartPlugin<
   EchartsLineFormData,
   EchartsLineChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsLine'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('Evolution'),
         credits: ['https://echarts.apache.org'],
         description:
           t(`'Area charts are similar to line charts in that they represent variables with the same scale, but area charts stack the metrics on top of each other.`),
         exampleGallery: [
           { url: thumbnail },
           { url: example1 },
           { url: example2 },
         ],
         name: t('Area Chart'),
         tags: [
           t('Popular'),
           t('ECharts'),
           t('Stacked'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 